import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ModalRightService } from '../../../../../services/modal-right/modal-right.service';
import { ParametreDocumentStateService } from '../../../../../services/parametre-document/parametre-document-state.service';
import {
    getVenteDocumentTypeLabel,
    PARAMETRE_TYPE_DOCUMENT_VENTE
} from '../../../../../services/parametre-document/parametre-document-type-ids';
import { VenteAchatParametreRow } from '../../../../../services/parametre-document/parametre-document-settings.service';
import {
    DEFAULT_HEX_COLOR,
    isTruthyTinyInt,
    toHexColorInputValue
} from '../../../../../services/parametre-document/parametre-doc-api-normalize';

@Component({
    selector: 'app-doc-vente-devis',
    templateUrl: './doc-vente-devis.component.html',
    styleUrls: ['./doc-vente-devis.component.scss']
})
export class DocVenteDevisComponent implements OnInit {
    private readonly typeId = PARAMETRE_TYPE_DOCUMENT_VENTE.devis;

    readonly documentTypeLabel = getVenteDocumentTypeLabel(this.typeId);

    /** Libellé affiché dans le champ ; par défaut = type de document. */
    labelText = this.documentTypeLabel;

    numberValue = 1;
    stepValue = 1;
    minValue = 0;
    maxValue?: number;

    disabledValueIncrement = false;
    disabledValueDecrement = false;

    couleurText = DEFAULT_HEX_COLOR;
    datePaiement: 'jours' | 'mois' | 'annee' = 'jours';
    insrOrigArtcl = false;
    affMontantTotaux = false;
    affInfContact = false;
    affCourteDesp = false;
    affInfos = false;
    noteText = '';

    saving = false;

    constructor(
        private customizerService: ModalRightService,
        private state: ParametreDocumentStateService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.state.ensureLoaded().subscribe({
            next: () => this.applyRowFromState(),
            error: () => this.toastr.error('Impossible de charger les paramètres.', 'Erreur')
        });
    }

    private applyRowFromState(): void {
        const row = this.state.getRowForType(this.typeId);
        if (row == null) {
            this.applyDefaultsSansDonneesApi();
            this.updateDisabledStates();
            return;
        }
        this.labelText = row.label?.trim() || this.documentTypeLabel;
        this.couleurText = toHexColorInputValue(row.couleur);
        this.datePaiement = (row.date_paiement as 'jours' | 'mois' | 'annee') ?? 'jours';
        this.numberValue = row.nb_date != null ? Number(row.nb_date) : 1;
        this.insrOrigArtcl = isTruthyTinyInt(row.insr_orig_artcl);
        this.affMontantTotaux = isTruthyTinyInt(row.aff_montant_totaux);
        this.affInfContact = isTruthyTinyInt(row.aff_inf_contact);
        this.affCourteDesp = isTruthyTinyInt(row.aff_courte_desp);
        this.affInfos = isTruthyTinyInt(row.aff_num_bn_liv);
        this.noteText = row.note ?? '';
        this.updateDisabledStates();
    }

    /** Aucune ligne `vente_achat` pour ce type : tout décoché, champs vides */
    private applyDefaultsSansDonneesApi(): void {
        this.labelText = this.documentTypeLabel;
        this.couleurText = toHexColorInputValue('');
        this.datePaiement = 'jours';
        this.numberValue = 1;
        this.insrOrigArtcl = false;
        this.affMontantTotaux = false;
        this.affInfContact = false;
        this.affCourteDesp = false;
        this.affInfos = false;
        this.noteText = '';
    }

    private buildPatch(): Partial<VenteAchatParametreRow> {
        return {
            label: this.labelText?.trim() || null,
            couleur: this.couleurText || null,
            date_paiement: this.datePaiement,
            nb_date: this.numberValue,
            insr_orig_artcl: this.insrOrigArtcl ? 1 : 0,
            aff_montant_totaux: this.affMontantTotaux ? 1 : 0,
            aff_inf_contact: this.affInfContact ? 1 : 0,
            aff_courte_desp: this.affCourteDesp ? 1 : 0,
            aff_num_bn_liv: this.affInfos ? 1 : 0,
            note: this.noteText || null
        };
    }

    saveParametreDocument(): void {
        this.saving = true;
        this.state
            .saveWithVenteAchatPatch(this.typeId, 'vente', this.buildPatch())
            .pipe(finalize(() => (this.saving = false)))
            .subscribe({
                next: () => this.toastr.success('Paramètres enregistrés.', 'Succès'),
                error: (err) => {
                    const msg = err?.error?.message ?? err?.message ?? 'Erreur serveur';
                    this.toastr.error(msg, 'Enregistrement');
                }
            });
    }

    increment(): void {
        this.numberValue += this.stepValue ?? 1;
        this.emitChange(this.numberValue);
        this.updateDisabledStates();
    }

    decrement(): void {
        this.numberValue -= this.stepValue ?? 1;
        this.emitChange(this.numberValue);
        this.updateDisabledStates();
    }

    emitChange(value: number): void {
        console.log('Value changed:', value);
    }

    private updateDisabledStates(): void {
        this.disabledValueDecrement = this.numberValue <= this.minValue;

        if (this.maxValue !== undefined) {
            this.disabledValueIncrement = this.numberValue >= this.maxValue;
        } else {
            this.disabledValueIncrement = false;
        }
    }

    appercue(): void {
        this.customizerService.open();
    }
}
